import {persianCopy} from './persianTranslations.js';
const localizedCopy = {
  "tr": [
    "Mevcut TEST videolarındaki soruları kaynak kareleriyle keşfedin.",
    "Bu özel arşiv yalnız yetkili hesapla görüntülenir.",
    "Arşiv yüklenemedi.",
    "Tekrar dene",
    "Sorularda ara",
    "Soru veya konu…",
    "soru",
    "Cevap zaman aralığı henüz doğrulanmadı.",
    "Kitap pasajı henüz bağlanmadı.",
    "Videoda birden fazla soru var; cevaplar ayrı ayrı eşlenecek.",
    "Transkript dosyası eşlendi; cevap doğrulaması bekleniyor.",
    "Henüz doğrulanmış cevap yok.",
    "Bu aramada soru bulunamadı.",
    "Yükleniyor…",
    "Soru başlığı inceleme bekliyor."
  ],
  "en": [
    "Explore questions from current TEST videos with their source frames.",
    "This private archive requires an authorized account.",
    "Unable to load the archive.",
    "Try again",
    "Search questions",
    "Question or topic…",
    "questions",
    "The answer time range has not been verified.",
    "No book passage is linked yet.",
    "This video has multiple questions; answers will be aligned separately.",
    "Transcript file matched; answer verification pending.",
    "No verified answers yet.",
    "No questions found.",
    "Loading…",
    "Question title awaits review."
  ],
  "de": [
    "Fragen der aktuellen TEST-Videos mit Quellbildern entdecken.",
    "Dieses private Archiv erfordert ein berechtigtes Konto.",
    "Archiv konnte nicht geladen werden.",
    "Erneut versuchen",
    "Fragen suchen",
    "Frage oder Thema…",
    "Fragen",
    "Der Antwortzeitraum ist noch nicht geprüft.",
    "Noch keine Buchpassage verknüpft.",
    "Dieses Video enthält mehrere Fragen; Antworten werden einzeln zugeordnet.",
    "Transkriptdatei zugeordnet; Antwortprüfung ausstehend.",
    "Noch keine geprüften Antworten.",
    "Keine Fragen gefunden.",
    "Wird geladen…",
    "Fragetitel wartet auf Prüfung."
  ],
  "fr": [
    "Découvrez les questions des vidéos TEST avec leurs images sources.",
    "Ces archives privées nécessitent un compte autorisé.",
    "Impossible de charger les archives.",
    "Réessayer",
    "Rechercher des questions",
    "Question ou sujet…",
    "questions",
    "La plage temporelle de la réponse reste à vérifier.",
    "Aucun passage de livre lié pour le moment.",
    "Cette vidéo contient plusieurs questions; les réponses seront associées séparément.",
    "Fichier de transcription associé; réponse à vérifier.",
    "Aucune réponse vérifiée pour le moment.",
    "Aucune question trouvée.",
    "Chargement…",
    "Le titre de la question attend une vérification."
  ],
  "es": [
    "Explore preguntas de los vídeos TEST con sus imágenes originales.",
    "Este archivo privado requiere una cuenta autorizada.",
    "No se pudo cargar el archivo.",
    "Reintentar",
    "Buscar preguntas",
    "Pregunta o tema…",
    "preguntas",
    "El intervalo de la respuesta aún no está verificado.",
    "Todavía no hay pasajes de libros vinculados.",
    "El vídeo tiene varias preguntas; cada respuesta se vinculará por separado.",
    "Transcripción vinculada; respuesta pendiente de verificación.",
    "Aún no hay respuestas verificadas.",
    "No se encontraron preguntas.",
    "Cargando…",
    "El título de la pregunta está pendiente de revisión."
  ],
  "ru": [
    "Вопросы из текущих видео TEST с исходными кадрами.",
    "Для частного архива нужна авторизованная учётная запись.",
    "Не удалось загрузить архив.",
    "Повторить",
    "Поиск вопросов",
    "Вопрос или тема…",
    "вопросов",
    "Временной интервал ответа ещё не проверен.",
    "Отрывок из книги ещё не связан.",
    "В видео несколько вопросов; ответы будут связаны отдельно.",
    "Файл расшифровки сопоставлен; проверка ответа ожидается.",
    "Проверенных ответов пока нет.",
    "Вопросы не найдены.",
    "Загрузка…",
    "Заголовок вопроса ожидает проверки."
  ],
  "ar": [
    "استكشف أسئلة فيديوهات TEST الحالية مع صورها الأصلية.",
    "يتطلب هذا الأرشيف الخاص حساباً مخولاً.",
    "تعذر تحميل الأرشيف.",
    "حاول مجدداً",
    "ابحث في الأسئلة",
    "سؤال أو موضوع…",
    "سؤال",
    "لم يتم التحقق من الفترة الزمنية للإجابة بعد.",
    "لم يتم ربط مقطع من كتاب بعد.",
    "يحتوي الفيديو على عدة أسئلة؛ ستتم مطابقة كل إجابة على حدة.",
    "تمت مطابقة ملف التفريغ؛ التحقق من الإجابة قيد الانتظار.",
    "لا توجد إجابات موثقة بعد.",
    "لم يتم العثور على أسئلة.",
    "جار التحميل…",
    "عنوان السؤال بانتظار المراجعة."
  ],
  "zh": [
    "通过原始画面探索当前 TEST 视频中的问题。",
    "此私人档案需要授权账户。",
    "无法加载档案。",
    "重试",
    "搜索问题",
    "问题或主题…",
    "个问题",
    "回答的时间范围尚未核实。",
    "尚未关联书籍段落。",
    "此视频包含多个问题；回答将分别匹配。",
    "已匹配转录文件；回答待核实。",
    "尚无已核实的回答。",
    "未找到问题。",
    "正在加载…",
    "问题标题待审核。"
  ]
};

localizedCopy.fa=persianCopy(localizedCopy.tr);
export default localizedCopy;
